<template>
  <AdminNavbar>
    <div
      class="bg-white rounded w-[800px] justify-center flex flex-col mx-auto"
    >
      <div class="flex justify-start p-3 border-b"></div>

      <div class="p-3 space-y-5">
        <div class="flex items-center w-full gap-5">
          <label for="name" class="w-1/5 text-end"
            >Нэр:<span class="text-red-500">*</span></label
          >
          <input
            type="text"
            placeholder="Нэр"
            class="w-4/5 border rounded p-1.5"
            v-model="form.name"
          />
        </div>

        <div class="flex gap-5">
          <h4 class="w-1/5 text-end">
            Лого:<span class="text-red-500">*</span>
          </h4>

          <div class="space-y-3 w-4/5">
            <div
              class="flex flex-col justify-center items-center w-full"
              :class="mainImage ? 'w-3/4' : 'h-40 w-40'"
            >
              <img
                :src="imageSrc"
                alt="image"
                :class="!mainImage ? 'w-14 h-14' : ''"
              />
              <span v-if="!mainImage" class="text-xs text-gray-500"
                >Зураг байхгүй байна</span
              >
            </div>
            <input
              id="name"
              name="name"
              type="file"
              class="w-full border border-gray-300 rounded p-2"
              @change="onImageChange"
              accept="image/jpeg, image/png"
            />
          </div>
        </div>

        <div class="flex items-center w-full gap-5">
          <label for="link" class="w-1/5 text-end">Вэбсайтын холбоос:</label>
          <input
            id="link"
            name="link"
            type="text"
            placeholder="Линк"
            class="w-4/5 border rounded p-1.5"
            v-model="form.link"
          />
        </div>

        <div class="flex justify-center">
          <button
            @click="uploadLogo()"
            class="flex justify-center items-center gap-1 w-[10rem] text-white rounded py-2"
            :class="
              form.id
                ? 'bg-blue-500 hover:bg-blue-600'
                : 'bg-[#28a745] hover:bg-[#208537]'
            "
          >
            <font-awesome-icon
              :icon="form.id ? 'fa-solid fa-pen' : 'fa-solid fa-plus'"
            />
            {{ form.id ? "Хадгалах" : "Нэмэх" }}
          </button>
        </div>
      </div>
    </div>
    <SuccessModal v-if="success" :success="success" @close-alert="closeAlert" />
  </AdminNavbar>
</template>

<script>
import adminInstance from "@/lib/adminInstance";
import SuccessModal from "@/components/ui/SuccessModal.vue";
import { ref } from "vue";
import AdminNavbar from "@/components/admin/AdminNavbar.vue";

export default {
  name: "MMEditBoardMem",
  props: {
    data: Object,
  },
  components: { SuccessModal, AdminNavbar },
  setup(props, { emit }) {
    const form = ref({
      id: null,
      name: null,
      link: null,
    });

    const success = ref(null);

    // Main image
    const defaultImage = require("@/assets/svg/image-not-found-icon.svg");
    const imageSrc = ref(defaultImage);
    const mainImage = ref("");

    const onImageChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        imageSrc.value = URL.createObjectURL(file);
        mainImage.value = file;
      } else {
        imageSrc.value = defaultImage;
        mainImage.value = null;
      }
    };

    // onMounted(() => {
    //   if (props.data) {
    //     form.value.id = props.data.id;
    //     form.value.name = props.data.name;
    //     form.value.link = props.data.link;
    //     imageSrc.value = props.data.logo;
    //     mainImage.value = props.data.logo;
    //   }
    // });

    const resetForm = () => {
      form.value = {
        id: null,
        name: null,
        link: null,
      };
      imageSrc.value = defaultImage;
      mainImage.value = null;
    };

    const isValid = () => {
      if (!form.value.name) return alert("Нэр оруулна уу");
      if (!mainImage.value) return alert("Логог оруулна уу");

      return true;
    };

    const uploadLogo = async () => {
      if (!isValid()) return;

      const formData = new FormData();
      formData.append("name", form.value.name);
      formData.append("image", mainImage.value);
      formData.append("link", form.value.link);
      formData.append("board_member", true);
      formData.append("main_member", true);
      formData.append("responsible_mining", true);

      try {
        let res;
        if (form.value.id) {
          formData.append("id", form.value.id);
          res = await adminInstance.post("/update/membership", formData);
        } else {
          res = await adminInstance.post("/insert/membership", formData);
        }

        if (res.status === 200) {
          success.value = "Амжилттай шинэчлэгдлээ.";
          resetForm();

          setTimeout(() => {
            success.value = null;
          }, 3000);
        }
      } catch (err) {
        alert(`Алдаа гарлаа: ${err}`);
      }
    };

    const closeAlert = () => {
      success.value = null;
    };

    const cancelEdit = () => {
      resetForm();
      emit("cancel-edit");
    };

    return {
      form,
      imageSrc,
      mainImage,
      onImageChange,
      uploadLogo,
      resetForm,
      closeAlert,
      success,
      cancelEdit,
    };
  },
};
</script>
